import {
    CalendarClient
} from '../clients/CalendarClient';

export const CalendarStore = {
    namespaced: true,
    state: {
        rawEvents: [],
        dateSortedList: [],
        futureEvents: [],
        bookings: [],
        projects: [],
        todos: [],
        errors: [],
    },

    // getters: {
    //     DOCUMENT_BY_ID: state => id => {
    //         return state.documents.find(document => document.id === id);
    //     },
    // },
    mutations: {
        //synchronous
        SET_RAW_EVENTS: (state, rawEvents) => {
            state.rawEvents = rawEvents;
        },
        SET_ERRORS: (state, errors) => {
            state.errors = errors;
        },
    },

    actions: {
        //asynchronous
        GET_EVENTS: async ({
            commit
        }, groupId) => {
            return CalendarClient.getCalendar(groupId)
                .then(function (res) {
                    commit('SET_RAW_EVENTS', res.data.events);
                })
                .catch((err) => {
                    commit('SET_ERRORS', err)
                });
        },

    },
};